/**
 * Frontend mirror of backend `TGD_ROLES` (`roleAdmin.constants.ts`).
 * Keep in sync — CRM IAM normalize must not strip `payment_ops`.
 */

export const TGD_ROLES = {
    SUPERADMIN: 'superadmin',
    ACCOUNTMANAGER: 'accountmanager',
    PARTNERADMIN: 'partneradmin',
    PAYMENT_OPS: 'payment_ops',
    /** @deprecated → payment_ops */
    PARTNER_OPS: 'partner_ops',
    TAGADAPAYMENT_ADMIN: 'tagadapaymentAdmin',
    /** TagadaRx admin — full Rx module management within scope. */
    RX_ADMIN: 'rx_admin',
    /** TagadaRx ops — patient support desk within scope. */
    RX_OPS: 'rx_ops',
    FOUNDER: 'founder',
    CRM_ADMIN: 'crmAdmin',
} as const;

export type TgdRole = (typeof TGD_ROLES)[keyof typeof TGD_ROLES];

export const VALID_TGD_ROLES: readonly TgdRole[] = [
    TGD_ROLES.SUPERADMIN,
    TGD_ROLES.ACCOUNTMANAGER,
    TGD_ROLES.PARTNERADMIN,
    TGD_ROLES.PAYMENT_OPS,
    TGD_ROLES.PARTNER_OPS,
    TGD_ROLES.TAGADAPAYMENT_ADMIN,
    TGD_ROLES.RX_ADMIN,
    TGD_ROLES.RX_OPS,
    TGD_ROLES.FOUNDER,
    TGD_ROLES.CRM_ADMIN,
];

const CANONICAL_BY_LOWER: ReadonlyMap<string, TgdRole> = new Map(
    VALID_TGD_ROLES.map((r) => [r.toLowerCase(), r]),
);

export function normalizeTgdRole(input: string): TgdRole | null {
    if (typeof input !== 'string' || input.length === 0) return null;
    return CANONICAL_BY_LOWER.get(input.trim().toLowerCase()) ?? null;
}

export function normalizeTgdRoles(input: readonly string[]): TgdRole[] {
    const seen = new Set<TgdRole>();
    const out: TgdRole[] = [];
    for (const raw of input) {
        const normalised = normalizeTgdRole(raw);
        if (normalised === null) continue;
        if (seen.has(normalised)) continue;
        seen.add(normalised);
        out.push(normalised);
    }
    return out;
}
